var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.179,
    height: 24.517,
    viewBox: "0 0 27.179 24.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1081",
    "data-name": "Ret\\xE2ngulo 1081",
    width: 22.987,
    height: 19.222
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 4.975, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M22.987,1.613q-.375,1.744-.75,3.488Q20.869,11.522,19.5,17.943a2.48,2.48,0,0,1-.269.759.958.958,0,0,1-1.143.483,1.93,1.93,0,0,1-.7-.333c-1.634-1.2-3.271-2.4-4.9-3.6-.178-.132-.273-.116-.426.034-.78.764-1.573,1.516-2.361,2.272a1.478,1.478,0,0,1-.8.467c-.236.035-.279-.012-.261-.248q.108-1.455.208-2.91c.048-.679.1-1.358.139-2.037a.455.455,0,0,1,.181-.32q1.844-1.658,3.687-3.317l4.622-4.156,1.236-1.11a1.6,1.6,0,0,0,.143-.143c.054-.063.111-.134.058-.221a.212.212,0,0,0-.218-.087,1.155,1.155,0,0,0-.5.182l-5.587,3.5Q9.45,9.138,6.3,11.118a.523.523,0,0,1-.48.07Q3.325,10.4.831,9.629a1.548,1.548,0,0,1-.644-.35.513.513,0,0,1-.065-.728,1.455,1.455,0,0,1,.6-.465c.74-.344,1.512-.606,2.272-.9q6.257-2.407,12.518-4.8L21.347.144a1.55,1.55,0,0,1,.785-.133,1.015,1.015,0,0,1,.855.838Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.3942eb628b76c19d03798b356f7fd74c.svg";
export { ForwardRef as ReactComponent };